import {Injectable, EventEmitter} from '@angular/core';

// Classes
import {ProductCategory} from '../classes/product-category';
import {Product} from '../classes/product';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:SceneService'));

@Injectable()
export class SceneService {

    private _sceneProducts: Array<Product> = [];
    private _catalogService;
    private _productsService;

    public state = {
        totalPrice: 0,
        isEmpty: true,
    };

    // TODO: Temporary, remove all events, use state store
    public events = {
        sceneUpdated: new EventEmitter(),
        // productAddedToScene: new EventEmitter(),
        // productRemovedFromScene: new EventEmitter(),
    //     sceneIsEmpty: new EventEmitter()
    };

    
    constructor () {
        // 'Construct scene service' );
    }

    
    public init (catalogService) {
        // 'Initialise dynamic properties service' );
        this._catalogService = catalogService;
        this._productsService = catalogService._productsService;
    }

    
    private _addProduct (product: Product) {
        // 'Add "' + product.code + '" product in scene' );
        
        this.state.isEmpty === false && (this.state.isEmpty = true);

        // // Get product category
        // let prodCateg: ProductCategory = product.getCategory();
        // debugOff( 'Product category:', prodCateg );
        //
        // // Check if multiple products from same category are NOT allowed
        // if (prodCateg.addToSceneMultiple === false) {
        //
        //     this.removeProductsByCategory( prodCateg );
        // }

        // If generator added, update super compatible products
        // if (product.categoryId === 'generators') {
        //     this._productsService.setSuperProducts( product.superGenerator );
        // }

        // Update package and dynamic properties
        product.refreshState();

        // Add new product in scene
        this._sceneProducts.push( product );

        // Check for incompatible products
        // this._hideProdsIncompatibleWithScene();
        // this._removeIncompatibleProdsFromScene( product );
        // product.checkIsDisplayed();

        product.isAddedToScene = true;

        // Sort scene in order to show graphics layers in proper order
        // this._sortSceneProducts();

        this.events.sceneUpdated.emit( null );
        // this.events.productAddedToScene.emit({ product: product });
    }

    
    private _removeProduct (product: Product) {
        // 'Remove "' + product.code + '" product from scene' );
        var index = this._sceneProducts.indexOf( product );

        index >= 0 && this._sceneProducts.splice( index, 1 );

        // Set scene as empty if no products are selected
        if (this._sceneProducts.length === 0 &&
            this.state.isEmpty === true
        ) {
            this.state.isEmpty = false;
            // this.events.sceneIsEmpty.emit(null);
        }

        // If generator added, update super compatible products
        // if (product.categoryId === 'generators') {
        //     this._productsService.setSuperProducts( false );
        // }

        product.isAddedToScene = false;

        // Check for incompatible products
        // this._hideProdsIncompatibleWithScene();
        // product.checkIsDisplayed();

        this.events.sceneUpdated.emit( null );
        // this.events.productRemovedFromScene.emit({ product: product });
    }

    
    private _checkProductIsInScene (product: Product) {
        //'Check if "' + product.code + '" product is in scene');
        return this._sceneProducts.indexOf( product ) !== -1;
    }

    
    public emptyScene() {
        // 'Empty scene' );
        var tempSceneProdsList: Array<Product> = [];

        // Prevents the effects of shifting the products array while looping it at the same time
        this._sceneProducts.forEach(
            sceneProduct => tempSceneProdsList.push(sceneProduct)
        );

        tempSceneProdsList.forEach(
            sceneProduct => {
                sceneProduct.removeFromScene();
                sceneProduct.hideTooltip();
            }
        );
    }

    
    public getSceneProducts () {
        debugOff( 'Get scene products' );
        return this._sceneProducts;
    }

    
    public getSceneProductsByCategory (category: ProductCategory) {

        console.warn( 'REFACTOR getSceneProductsByCategory()' );

        // debugOff( 'Get scene products by "' + category.id + '"' );
        //
        // // Filter products by category id
        // return this._sceneProducts.filter( (product: Product) => {
        //     return product.categoryId === category.id;
        // } );
    }

    
    public removeProductsByCategory (category: ProductCategory) {     // Get products from same category
        // debugOff( 'Remove products from scene by "' + category.id + '" category' );

        console.warn( 'REFACTOR getSceneProductsByCategory()' );

        // let products = this.getSceneProductsByCategory( category );
        // debugOff( 'Scene category products:', products );
        //
        // // Remove products
        // products.forEach( (product: Product) => {
        //     console.log( product );
        //     product.removeFromScene();
        // });
    }

    
    public appendProductAPI (products: Array<Product>) {
        // 'Append product API' );

        products.forEach( product => {

            
            product.toggleInScene = () => {
                debugOff( 'Toggle add/remove "' + product.code + '" product in scene' );
                let isInScene = product.isAddedToScene;

                if (isInScene === true) {
                    product.removeFromScene();
                } else {
                    product.addToScene();
                }
            };

            
            product.addToScene = () => {
                debugOff( 'Add "' + product.code + '" product in scene' );
                this._addProduct( product );
            };

            
            product.removeFromScene = () => {
                debugOff( 'Remove "' + product.code + '" product from scene' );
                this._removeProduct( product );
            };
        });
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/services/scene-service.ts